import React, { useState } from 'react'
import { autocompleteHelpers } from 'elentari'
import mercadoriaRepository from './MercadoriaRepository'
import Autocomplete from '../../components/Autocomplete'
const { toOption } = autocompleteHelpers

export const loadMercadorias = async inputValue => {
  const response = await mercadoriaRepository.simpleList({
    filter: {
      where: {
        descricao: { ilike: `%${inputValue}%` },
        ativo: true
      },
      order: 'descricao asc',
      limit: 10
    }
  })
  if (response.ok) {
    return response.data.map(toOption('descricao'))
  }
  return []
}

const MercadoriaAutocomplete = props => {
  const [inputFocused, setInputFocused] = useState(false);

  const handleFocus = () => {
    if (!inputFocused) setInputFocused(true);
  };

  return (
    <Autocomplete
      {...props}
      labelOption="descricao"
      repository={mercadoriaRepository}
      loadOptions={inputFocused ? loadMercadorias : async () => []}
      onFocus={handleFocus}
      defaultOptions={false}
    />
  )
}

export default MercadoriaAutocomplete
